import React from 'react';

const shimmerClass = 'animate-pulse rounded';

const SkeletonBlock = ({ className = '' }) => (
  <div className={`${shimmerClass} bg-blue-100 ${className}`} />
);

export const ReportGeneratingSkeleton = () => (
  <div className="space-y-4">
    {/* Executive Summary Skeleton */}
    <div className="bg-white border border-gray-200 rounded-xl p-5">
      <div className="flex items-center gap-3 mb-4">
        <SkeletonBlock className="w-8 h-8 rounded-lg" />
        <SkeletonBlock className="h-5 w-48" />
      </div>
      <SkeletonBlock className="h-4 w-full mb-2" />
      <SkeletonBlock className="h-4 w-5/6 mb-2" />
      <SkeletonBlock className="h-4 w-4/6 mb-4" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">
        {[...Array(4)]?.map((_, i) => (
          <div key={i} className="bg-blue-50 rounded-lg p-3">
            <SkeletonBlock className="h-3 w-16 mb-2" />
            <SkeletonBlock className="h-6 w-24 mb-1" />
            <SkeletonBlock className="h-3 w-12" />
          </div>
        ))}
      </div>
    </div>

    {/* Metrics Dashboard Skeleton */}
    <div className="bg-white border border-gray-200 rounded-xl p-5">
      <div className="flex items-center gap-3 mb-4">
        <SkeletonBlock className="w-8 h-8 rounded-lg" />
        <SkeletonBlock className="h-5 w-40" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Bar chart skeleton */}
        <div>
          <SkeletonBlock className="h-4 w-32 mb-3" />
          <div className="space-y-2">
            {[...Array(7)]?.map((_, i) => (
              <div key={i} className="flex items-center gap-2">
                <SkeletonBlock className="h-3 w-16" />
                <SkeletonBlock className="h-5 rounded" style={{ width: `${40 + Math.random() * 50}%` }} />
                <SkeletonBlock className="h-3 w-10" />
              </div>
            ))}
          </div>
        </div>
        {/* Line chart skeleton */}
        <div>
          <SkeletonBlock className="h-4 w-32 mb-3" />
          <SkeletonBlock className="h-40 w-full rounded-lg" />
        </div>
      </div>
    </div>

    {/* Report Sections Skeleton */}
    {[...Array(4)]?.map((_, i) => (
      <div key={i} className="bg-white border border-gray-200 rounded-xl p-5">
        <div className="flex items-center gap-3">
          <SkeletonBlock className="w-8 h-8 rounded-lg" />
          <SkeletonBlock className="h-5 w-56" />
          <SkeletonBlock className="ml-auto h-4 w-4 rounded" />
        </div>
      </div>
    ))}
  </div>
);

export default ReportGeneratingSkeleton;
